<template>
  <div class="home">
    <div class="logo">
      <h1>数字地图</h1>
      <p>智慧应急问答系统</p>
    </div>
    <div class="container flex">
      <Left />
      <div class="answer-box flex">
        <div class="talks-box" ref="scrollableDiv">
          <div v-for="(item, i) in talks" :key="i" :class="{ talks: true, 'talks-right': item.type !== 'ask' }">
            <div class="res">
              <p class="time">{{ item.time }}</p>
              <div v-if="item.type === 'ask'" class="ask talk-text">
                <Loading v-if="item.loading" />
                <span v-else>{{ item.content }}</span>
              </div>
              <div v-else class="flex response">
                <div :class="{ answer: !item.isImg, 'talk-text': !item.isImg }">
                  <Loading v-if="item.loading" />
                  <img v-if="item.isImg" :src="item.imgUrl" @load="imageLoad(item)" alt="" />
                  <VueMarkdown v-else :source="item.content"></VueMarkdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="humans flex">
        <!-- <div id="humans" class="flex"></div> -->
      </div>
    </div>
    <img v-if="!isRecording" class="recoding" src="@/assets/images/麦克风.png" alt="" />
    <div class="caption flex">
      <p v-if="imgContent" class="talk-text" ref="talkTextRef">
        {{ talkText }}
      </p>
    </div>
    <div class="input flex" v-if="isTest">
      <input type="text" placeholder="请简单描述你的问题" v-model="issue" @keyup.enter="testAsk(issue)" />
    </div>
  </div>
</template>

<script>
  import { v4 as uuidv4 } from "uuid";
  import { ttsRes } from "@/serve/index";
  import { talkTime, clearChat, extractAsrContent, replaceTTS, replaceAsrContent, terminalWords } from "@/utils";
  import Loading from "@/components/Loading.vue";
  import Left from "./left.vue";
  import VueMarkdown from "vue-markdown";
  import AsrManager from "@/modules/asrManager";
  import LLMManager from "@/modules/llmManager";
  import LLMStreamParser from "@/modules/llmStreamParser";

  const getAsrUrl = (pauseTime) => {
    const protocol = window.location.protocol === "https:" ? "wss" : "ws";
    const pauseParam = pauseTime ? `&pauseTime=${pauseTime}` : "";
    return `${protocol}://${window.location.host}/asr-ws/runtime/v2/recognize?productId=914004114${pauseParam}`;
  };

  const toTtsProxyUrl = (url) => {
    if (!url) return url;
    return url
      .replace("http://tts.dui.ai/", `${window.location.origin}/tts/`)
      .replace("https://consultassistant.duiopen.com/tts/", `${window.location.origin}/tts/`);
  };

  export default {
    name: "Index",
    components: {
      Loading,
      Left,
      VueMarkdown,
    },
    data() {
      return {
        talkTime: talkTime,
        talks: [],
        // 问题
        issue: "你是谁",
        audioContext: null,
        isRecording: false,
        stream: null,
        timer1: null,
        timer2: null,
        listen: false,
        audioUrls: [],
        audioIndex: 0,
        audio: null,
        processor: null,
        playTimer: null,
        talkText: "",
        answer: "",
        intervalId: null,
        askObj: {},
        currentRequestId: null,
        lastAskFailed: false,

        wakeupManager: null,
        askManager: null,
        llmManager: new LLMManager(),
        controller: new AbortController(),
        currentSession: null,
        currentPlayId: null,
        llmState: "IDLE", // "IDLE" | "REQUESTING" | "STREAMING" | "FINISHED" | "ERROR",
        playbackState: "IDLE", // "IDLE" | "PLAYING" | "WAIT_TYPING",
        asrState: "WAKEUP", // "WAKEUP" | "LISTENING" | "CLOSED",
        isTest: false,
      };
    },
    computed: {
      lastTalk() {
        return this.talks.at(-1) || {};
      },
      imgContent() {
        return !!(this.lastTalk?.isImg && this.talkText.length > 0);
      },
    },

    watch: {
      talks: {
        deep: true,
        handler() {
          this.$nextTick(this.scrollToBottom);
        },
      },
    },
    methods: {
      removeTalk() {
        if (this.lastTalk.loading && this.lastTalk.type === "ask") {
          this.talks.pop();
        }
      },
      createSession() {
        // 先停止上一轮
        this.stopAudio();
        const session = {
          id: uuidv4(),
          stopped: false,
        };
        this.currentSession = session;
        return session;
      },
      // 统一中断
      interruptSession(force = false) {
        if (this.playbackState !== "PLAYING" && !force) return;
        if (this.currentSession) {
          this.currentSession.stopped = true;
        }
        this.stopAudio(); // ✅ 现在是安全版本
      },
      // 获取录音数据
      async getAudio() {
        if (this.isRecording || this.audioContext || this.isTest) return;
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)({
          sampleRate: 16000, // 设置采样率为16KHz
        });
        // 加载 AudioWorkletProcessor
        if (!this.audioContext.audioWorklet) {
          alert("AudioWorklet not supported in this environment");
        }
        try {
          await this.audioContext.audioWorklet.addModule(`${process.env.BASE_URL}audio-processor.js`);
        } catch (e) {
          console.error(e);
        }
        this.stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        this.audioWorkletNode = new AudioWorkletNode(this.audioContext, "audio-processor");
        this.audioWorkletNode.port.onmessage = (event) => {
          // 处理从 AudioWorkletProcessor 发送过来的 PCM 数据
          if (this.asrState === "WAKEUP") {
            this.wakeupManager.send(event.data);
          }
          if (this.asrState === "LISTENING") {
            this.askManager.send(event.data);
          }
        };
        const source = this.audioContext.createMediaStreamSource(this.stream);
        source.connect(this.audioWorkletNode);
        this.audioWorkletNode.connect(this.audioContext.destination);
        this.isRecording = true;
      },
      // 对话区域滚动到最底部
      scrollToBottom() {
        this.$nextTick(() => {
          this.$refs.scrollableDiv.scrollTo({
            top: this.$refs.scrollableDiv.scrollHeight,
            behavior: "smooth",
          });
        });
      },
      // 图片内容介绍文本滚动到最底部
      talkTextScroll() {
        this.$nextTick(() => {
          this.$refs.talkTextRef.scrollTo({
            top: this.$refs.talkTextRef.scrollHeight,
            behavior: "smooth",
          });
        });
      },
      // ======== 唤醒服务相关事件 ========
      // 进入唤醒模式
      enterWakeupMode() {
        this.askManager?.close();
        // this.isWakeupMode = true;
        this.wakeupManager?.connect();
        this.asrState = "WAKEUP";
      },
      // 播报唤醒词
      playWakeupAudio() {
        const audio = new Audio(`${process.env.BASE_URL}/audio/wakeup.mp3`);
        audio.play();
        audio.onended = () => {
          this.talkText = "";
          if (this.asrState !== "LISTENING") {
            this.openASR();
          }
          this.clearTimer("timer1");
          this.timer1 = setTimeout(() => {
            if (!this.listen) {
              // this.asrStatus = "close";
              this.clearTimer("timer1");
              this.removeTalk();
              this.issue = "";
              this.enterWakeupMode();
            }
          }, window.config.pickupTime);
        };
      },
      wakeupResult(res) {
        if (this.loading) {
          return;
        }
        console.log(res);
        const { status, result } = res;
        const { pinyin, end } = result.asr;
        if (status === 200 && end && pinyin.includes("tu tu")) {
          this.interruptSession(true);
          this.clearImageDisplay();
          this.playWakeupAudio();
        }
      },
      // ========  问题识别服务相关事件 ========
      enterAskMode() {
        this.wakeupManager?.close();
        this.askManager?.connect();
      },
      async askOpen() {
        await this.getAudio();
        this.asrState = "LISTENING";
      },
      askResult(res) {
        this.listen = true;
        this.askObj.loading = false;
        const result = res.result.asr;
        if (!result.end) {
          this.askObj.content = result.var;
          // 判断是否在识别中途进行唤醒
          // 1、立即中断当前asr识别，免得把唤醒词作为asr识别进去
          // 2、当前answer清空，等唤醒词播报结束之后重新开始answer
          const hit = terminalWords.some((item) => result.var.includes(item));
          if (hit) {
            this.talks.pop();
            this.enterWakeupMode();
            this.playWakeupAudio();
          }
        }
        if (res.status === 200 && result.end) {
          const text = replaceAsrContent(result.pinyin, result.text);
          this.listen = false;
          this.issue = "";
          this.askObj.content = text;
          this.askObj.loading = false;
          this.askManager?.close();
          const isOpen = window.config.speechArr.find((item) => text.includes(item));
          if (isOpen) {
            this.wakeupManager?.close();
            this.stopRecording();
            this.loading = false;
            // this.isFinal = true;
            window.open("http://metaverse.sipac.gov.cn:8181/twin-operation-portal/#/vr", "_blank");
          } else {
            // 开始请求大模型
            this.loading = true;
            this.enterWakeupMode();
            this.askModal(this.askObj.content);
          }
        }
      },
      // 清除定时器
      clearTimer(timer, type = "timeout") {
        if (this[timer]) {
          type === "timeout" ? clearTimeout(this[timer]) : clearInterval(this[timer]);
          this[timer] = null;
        }
      },
      openASR() {
        if (this.lastTalk.end_asr) {
          this.lastTalk.end_asr = false;
          return;
        }
        this.asrState = "LISTENING";
        this.enterAskMode();
        console.log("连接asr服务");
        this.askObj = {
          type: "ask",
          content: "",
          loading: true,
          time: this.talkTime(),
        };
        this.talks.push(this.askObj);
      },
      stopRecording() {
        if (!this.isRecording) return;
        if (this.audioWorkletNode) {
          this.audioWorkletNode.port.close(); // 关闭 AudioWorkletNode 的端口
          this.audioWorkletNode.disconnect(); // 断开连接
          this.audioContext.close(); // 关闭 AudioContext
          this.audioWorkletNode = null; // 清空引用
          this.audioContext = null;
        }
        if (this.stream) {
          const audioTracks = this.stream.getAudioTracks();
          audioTracks.forEach((track) => {
            track.stop(); // 停止音频轨道
          });
          this.stream = null;
        }
        this.isRecording = false;
      },
      // 展示asr识别到的文本
      async appendAnswer(obj, text) {
        text = extractAsrContent(text);
        obj.loading = false;
        obj.content += text;
        // 播报的时候要进行处理
        await this.getAudioUrl(text, this.currentSession);
      },
      async handleAskFail(obj, err) {
        // ✅ 如果上一次也是失败，本次又失败：即如果连续两次请求失败，alert
        if (this.lastAskFailed) {
          alert("大模型繁忙中，请稍后再试");
        }
        // ✅ 标记本次失败
        this.lastAskFailed = true;
        let errStr = typeof err === "string" ? err : err.msg;
        errStr += "请稍后再试！";
        this.appendAnswer(obj, errStr);
      },

      testAsk(msg) {
        this.finishPlayback();
        const obj = {
          type: "ask",
          loading: false,
          content: msg,
          time: this.talkTime(),
        };
        this.talks.push(obj);
        this.askModal(msg);
      },
      resetLLMState() {
        this.interruptSession();
        this.answer = "";
        this.talkText = "";
        this.controller.abort("当前咨询过于频繁！");
        this.controller = new AbortController();
        this.llmState = "REQUESTING";
      },
      async askModal(question) {
        if (this.llmState === "REQUESTING" || this.llmState === "STREAMING") {
          alert("大模型繁忙中");
          this.llmState = "IDLE";
          this.loading = false;
          this.interruptSession(true);
          return;
        }
        const requestId = uuidv4();
        const parser = new LLMStreamParser();
        this.currentRequestId = requestId;
        const obj = {
          type: "answer",
          content: "",
          loading: true,
          isImg: false,
          imgUrl: "",
          loaded: false,
          requestId,
          time: this.talkTime(),
          end_asr: false,
        };
        this.talks.push(obj);
        const session = this.createSession();
        this.resetLLMState();
        this.llmManager.ask(question, {
          abortController: this.controller,
          onMessage: async (data) => {
            if (this.llmState === "REQUESTING") {
              this.llmState = "STREAMING";
            }
            if (session.stopped) return;
            const parsed = parser.handleMessage(data);
            if (!parsed) return;
            this.loading = false;
            if (parsed.type === "image") {
              obj.isImg = true;
              obj.imgUrl = parsed.imgUrl;
            }
            if (obj.isImg) {
              this.answer += parsed.content;
            }
            if (parsed.end_asr) {
              obj.end_asr = true;
            }
            if (parsed.type === "text") {
              this.appendAnswer(obj, parsed.content);
            }
          },
          onFinished: async (data) => {
            let diff = parser.handleWorkflowFinished(data.data.outputs.answer);
            if (diff) {
              this.appendAnswer(obj, diff);
              return;
            }
            if (!obj.content && data.data.outputs.answer) {
              if (data.data.outputs.answer.includes("[[END_ASR]]") && !obj.end_asr) {
                obj.end_asr = true;
              }
              this.appendAnswer(obj, data.data.outputs.answer);
            }
          },
          onEnd: async () => {
            if (session.stopped) return;
            this.llmState = "FINISHED";
            if (!obj.end_asr) {
              const end = "\n您还有什么问题吗？";
              this.answer += end;
              this.appendAnswer(obj, end);
            }
          },
          onError: (err) => {
            this.llmState = "IDLE";
            this.handleAskFail(obj, err);
          },
        });
      },
      // 图片加载完毕
      imageLoad(obj) {
        if (obj.requestId !== this.currentRequestId || this.playbackState === "PLAYING") return;
        obj.loaded = true;
        obj.loading = false;
        if (this.audioUrls.length > 0 && this.audioUrls[0].url) {
          this.playAudio(this.currentSession);
        }
      },
      // 统一播放结束入口
      finishPlayback() {
        if (this.currentSession?.stopped) return;
        this.audio = null;
        this.audioUrls = [];
        this.audioIndex = 0;
        this.currentSession = null;
        this.playbackState = "IDLE";
        this.llmState = "IDLE";
        if (this.asrState !== "LISTENING") {
          this.openASR();
        }

        this.timer2 = setTimeout(() => {
          if (!this.listen) {
            this.removeTalk();
            this.askManager?.close();
            // ✅ 清除图片文本
            this.clearImageDisplay();
            this.enterWakeupMode();
          }
        }, window.config.listenTime);
      },
      // 将文本转化为音频
      async getAudioUrl(text, session) {
        if (!text || clearChat(text).length === 0 || session.stopped) return;
        try {
          const recordId = uuidv4();
          this.audioUrls.push({ recordId, url: "", requestId: session.id });
          text = replaceTTS(text);
          ttsRes(text, recordId)
            .then(({ code, data }) => {
              if (session.stopped || session !== this.currentSession) return;
              if (code === 200) {
                const audioItem = this.audioUrls.find((item) => item.recordId === data.context.recordId);
                if (audioItem) {
                  audioItem.url = toTtsProxyUrl(data.tts.url);
                }
                // ✅ 图片模式兜底触发播放
                if (
                  this.lastTalk?.isImg &&
                  this.audioUrls[0]?.url &&
                  !this.audio &&
                  this.talks.at(-1)?.loaded && // 图片已加载
                  !session.stopped
                ) {
                  this.playAudio(this.currentSession);
                }
                if (this.audioUrls[0].url && !this.lastTalk?.isImg && !this.audio) {
                  this.playAudio(this.currentSession);
                }
              }
            })
            .catch((_) => {
              const index = this.audioUrls.findIndex((item) => item.recordId === recordId);
              if (index !== -1) {
                this.audioUrls.splice(index, 1); // 如果找不到对应的recordId，则从数组中移除该条记录
              }
            });
        } catch (err) {
          console.error("获取音频URL失败:", err);
          // 可根据需要添加异常处理逻辑，如重试或提示用户
        }
      },
      async playAudio(session) {
        if (!session || session.stopped) return;
        // ✅ 新一轮播放ID
        const playId = uuidv4();
        this.currentPlayId = playId;
        this.playbackState = "PLAYING";
        this.audioIndex = 0;
        this.playNextAudio(session, playId);
      },
      startImageTyping(playId) {
        if (!this.answer) return;
        let index = 0;
        this.talkText = "";
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
        this.intervalId = setInterval(() => {
          if (playId !== this.currentPlayId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
            return;
          }
          if (index < this.answer.length) {
            this.talkText += this.answer[index];
            index++;
            this.talkTextScroll();
          } else {
            clearInterval(this.intervalId);
            this.intervalId = null;
            if (this.playbackState === "WAIT_TYPING") {
              this.finishPlayback();
            }
          }
        }, 200);
      },
      waitFor(conditionFn, interval = 30) {
        return new Promise((resolve) => {
          const timer = setInterval(() => {
            if (conditionFn()) {
              clearInterval(timer);
              resolve();
            }
          }, interval);
        });
      },
      async playNextAudio(session, playId) {
        // ✅ 失效保护
        if (session?.stopped || this.playbackState !== "PLAYING") return;
        if (playId !== this.currentPlayId) {
          if (this.audio) this.audio.pause();
          return;
        }

        if (this.audioIndex >= this.audioUrls.length) {
          if (this.lastTalk?.isImg) {
            if (!this.intervalId) {
              // 打字已经结束
              this.finishPlayback();
            } else {
              this.playbackState = "WAIT_TYPING";
            }
          } else {
            this.finishPlayback();
          }
          return;
        }
        const item = this.audioUrls[this.audioIndex];
        await this.waitFor(() => item?.url || playId !== this.currentPlayId || session.stopped);
        if (playId !== this.currentPlayId || session.stopped) return;
        if (!item?.url) return;
        const audio = new Audio(item.url);
        this.audio = audio;
        try {
          const playPromise = audio.play();
          if (playPromise !== undefined) {
            await playPromise;
          }
        } catch (err) {
          // ✅ 只忽略打断类错误
          if (err.name !== "AbortError" && !err.message.includes("interrupted")) {
            console.error("audio play error:", err);
          }
          return;
        }
        // ✅ 图片模式打字效果
        if (this.lastTalk.isImg && this.audioIndex === 0) {
          this.startImageTyping(playId);
        }
        // ✅ 再次校验（防止播放过程中被打断）
        if (playId !== this.currentPlayId || this.playbackState !== "PLAYING") return;
        audio.onended = () => {
          if (playId !== this.currentPlayId) {
            audio.pause();
            return;
          }
          if (this.playbackState !== "PLAYING") return;
          this.audioIndex++;
          this.playNextAudio(session, playId);
        };
        audio.onerror = () => {
          if (playId !== this.currentPlayId) return;
          this.audioIndex++;
          this.playNextAudio(session, playId);
        };
      },
      clearImageDisplay() {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
        this.talkText = "";
        this.answer = "";
      },
      stopAudio() {
        // ✅ 让旧播放全部失效
        this.currentPlayId = null;
        this.playbackState = "IDLE";
        this.audioUrls = [];
        this.audioIndex = 0;
        if (this.audio) {
          try {
            this.audio.pause();
            this.audio.onended = null;
            this.audio.onerror = null;
            this.audio.onplay = null;
            // ✅ 不用 pause()
            this.audio.src = "";
            this.audio.load();
          } catch (e) {}

          this.audio = null;
        }
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      },
      initEvent() {
        if (!this.clickBody) {
          this.getAudio();
          this.wakeupManager.connect();
        }
      },
    },
    created() {
      // 创建唤醒实例
      this.wakeupManager = new AsrManager({
        url: getAsrUrl(),
        onResult: this.wakeupResult,
      });

      this.askManager = new AsrManager({
        url: getAsrUrl(window.config.asrPauseTime || 1000),
        onOpen: this.askOpen,
        onResult: this.askResult,
        onClose: () => (this.asrState = "CLOSED"),
      });
    },
    mounted() {
      this.clickBody = false;
      if (!this.isTest) {
        document.body.addEventListener("click", this.initEvent);
      }
    },
    beforeDestroy() {
      clearTimeout(this.timer1);
      clearTimeout(this.timer2);
      clearInterval(this.intervalId);
      clearInterval(this.playTimer);
      document.body.removeEventListener("click", this.initEvent);
      this.askManager?.close();
      this.wakeupManager?.close();
    },
  };
</script>
<style scoped lang="less">
  .home {
    position: relative;
    width: 100%;
    height: 100vh;
    .logo {
      position: absolute;
      z-index: 2;
      left: 40px;
      top: 20px;
      color: #fff;
      p {
        font-size: 24px;
      }
    }
    .video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
  }

  .recoding {
    position: fixed;
    width: 50px;
    bottom: 15vh;
    left: 1vw;
  }

  .talk-text {
    line-height: 34px;
    letter-spacing: 2px;
    font-size: 19px;
    padding: 24px 40px;
    width: fit-content;
    max-width: 90%;
    border-radius: 56px;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
  }

  .input {
    position: fixed;
    top: 90vh;
    padding: 0 24px;
    width: 20%;
    height: 40px;
    align-items: center;
    justify-content: space-between;
    background: rgba(78, 148, 145, 0.6);
    border: 1px solid #4e9491;
    border-radius: 20px;
    input {
      background: transparent;
      border: none;
      font-size: 16px;
      height: 100%;
      flex: 1;
      color: #fff;
      &:active,
      &:focus,
      &:focus-visible {
        border: none;
        outline: none;
      }
    }
  }

  .container {
    width: 100%;
    height: 100vh;
    background-image: url("../assets/images/bg.jpg");
    background-size: cover;
    background-position: center; /* 确保图像居中 */
    background-repeat: no-repeat; /* 防止图像重复 */
    padding: 0px 20px 0 40px;
    color: #fff;

    /*     &::before {
      content: "";
      position: absolute;
      inset: 0;
      background-image: url("../assets/images/bg.jpg");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      filter: blur(1px);
      transform: scale(1.05);
      z-index: 0;
    }

    & > * {
      position: relative;
      z-index: 1;
    } */

    .answer-box {
      flex-direction: column;
      position: relative;
      flex: 1;
      padding: 12vh 2.5vw 21vh 4vw;
      height: 100%;

      .talks-box {
        padding-bottom: 16px;
        flex: 1;
        overflow-y: auto;
      }
      .talks {
        position: relative;
        display: flex;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        .time {
          font-size: 14px;
        }
        img {
          width: 100%;
        }
      }
      .talks-left {
        justify-content: flex-start;
      }
      .res {
        width: 100%;
      }
      .talks-right {
        .res {
          height: 100%;
        }
        .response {
          width: 100%;
          justify-content: flex-end;
        }
        .time {
          text-align: right;
        }
      }
      .ask {
        background: rgba(37, 138, 206, 0.6);
        border: 1px solid #258ace;
        border-top-left-radius: 0;
      }
      .answer {
        background: rgba(0, 0, 0, 0.6);
        border: 1px solid #258ace;
        border-top-right-radius: 0;
      }
    }

    .humans {
      position: relative;
      width: 28%;
      align-items: center;
      #humans {
        position: absolute;
        width: 100%;
        height: 80%;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }
    }
  }

  .caption {
    position: fixed;
    // top: calc(100% - 20vh - 10px);
    left: calc(23% + 25px);
    width: calc(49% - 28px);
    bottom: 10vh;

    align-items: center;
    justify-content: flex-end;
    max-width: 100% !important;
    padding-left: 4vw;
    padding-right: 2.5vw;
    color: #fff;
    border-radius: 0;
    overflow-y: hidden;
    p {
      // max-height: 100px;
      line-height: 1.5em; /* 设置行高 */
      max-height: calc(3em + 32px); /* 允许最多两行文本可见 */
      padding: 16px 32px;
      width: 100%;
      max-width: 100%;
      background: rgba(37, 138, 206, 0.6);
      border: 1px solid #258ace;
      border-radius: 32px;
      border-top-right-radius: 0;
      overflow-y: auto;
    }
  }
</style>
